var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useRef, useState } from "react";
import layoutComponentsDictionary from "../layoutComponentsDictionary";
import { LayoutComponentDisplay } from "../layoutComponentDisplay";
import copy from "fast-copy";
import { FormSettingsContext, getColorStyle, getLayoutStyle, getStyleSpacing, scrollToEl, } from "../../utils";
import { useTranslation } from "react-i18next";
import { FormComponentButtons } from "../../formComponentButtons";
import "./settings";
import "./list";
import { LayoutButtons } from "../../layoutButtons";
import { BasicComponents } from "../../basicComponent";
/**
 * <b>Composants de rendu des dispositions d'affichage `layout-rows`</b>
 *
 * @param param0
 */
export function LayoutRows(_a) {
    var _b, _c, _d;
    var module = _a.module, viewType = _a.viewType, fieldDefs = _a.fieldDefs, record = _a.record, fetchedRecord = _a.fetchedRecord, layouts = _a.layouts, onHandleUpdate = _a.onHandleUpdate, validations = _a.validations, isStudioField = _a.isStudioField, isSelected = _a.isSelected, layoutParent = _a.layoutParent, viewScreen = _a.viewScreen;
    var _e = useState(copy(record)), editedRecord = _e[0], setEditedRecord = _e[1];
    var updateRecord = function (edited) {
        setEditedRecord(edited);
        onHandleUpdate && onHandleUpdate(edited);
    };
    //translator
    var t = useTranslation(["common", module]).t;
    var fieldIsUpdated = function (field, value) {
        var _a, _b;
        setEditedRecord(__assign(__assign({}, editedRecord), (_a = {}, _a[field] = value, _a)));
        onHandleUpdate && onHandleUpdate(__assign(__assign({}, editedRecord), (_b = {}, _b[field] = value, _b)));
    };
    // Css pour le studio
    var borderStyle = isStudioField
        ? "border border-gray-500 border-dashed hover:border-red-500"
        : "";
    var _f = useContext(FormSettingsContext), settings = _f.settings, editedSettings = _f.editedSettings;
    var refs = useRef(null);
    var onClickComponent = function (e) {
        e.stopPropagation();
        editedSettings(__assign(__assign({}, settings), { selected: layouts && layouts[0].id, parentId: layoutParent }));
        scrollToEl(refs && (refs === null || refs === void 0 ? void 0 : refs.current));
    };
    // si composant séléctionné
    useEffect(function () {
        isStudioField &&
            settings.selected === layouts[0].id &&
            editedSettings(__assign(__assign({}, settings), { target: layouts && layouts[0].id, type: layouts && layouts[0].type, component: layouts && layouts[0].components, selected: layouts && layouts[0].id, parentId: layoutParent, currentComponent: layouts[0] }));
    }, [isStudioField && settings.selected]);
    // Styles
    var _g = useState(), styles = _g[0], setStyles = _g[1];
    useEffect(function () {
        var _a, _b;
        var spacingStyle = (layouts[0].settings && __assign(__assign({}, getStyleSpacing(((_a = layouts[0].settings) === null || _a === void 0 ? void 0 : _a.styles) || {})), getColorStyle(((_b = layouts[0].settings) === null || _b === void 0 ? void 0 : _b.styles) || {}))) ||
            "";
        setStyles(__assign({}, spacingStyle));
    }, [(_c = (_b = layouts[0]) === null || _b === void 0 ? void 0 : _b.settings) === null || _c === void 0 ? void 0 : _c.styles]);
    var borderRadiusClass = "border-none rounded-bl-[var(--border-detail-bottomLeft)] rounded-br-[var(--border-detail-bottomRight)] rounded-tl-[var(--border-detail-topLeft)] rounded-tr-[var(--border-detail-topRight)]";
    return (_jsx("div", __assign({ className: "w-full ".concat(borderStyle, " border-none ").concat(borderRadiusClass, " overflow-hidden"), 
        //style={styles}
        ref: function (el) {
            if (el)
                refs.current = el;
        }, id: layouts[0].id }, { children: _jsxs("div", __assign({ className: "relative w-full  ".concat(borderRadiusClass), onClick: function (v) {
                isStudioField && onClickComponent(v);
            }, 
            //style={getLayoutStyle(isSelected === layouts[0].id)}
            style: __assign(__assign({}, getLayoutStyle(isSelected === layouts[0].id)), { background: (_d = styles === null || styles === void 0 ? void 0 : styles.background) !== null && _d !== void 0 ? _d : "var(--colors-tab-selected)" }) }, { children: [layouts[0].components.map(function (component, key) {
                    var componentType = component.type || "";
                    if ((component && componentType === "etc-field") ||
                        componentType === "header") {
                        return (_jsx("div", { children: _jsx(BasicComponents, { record: editedRecord, layoutType: componentType, meta: component || [], fieldDefs: fieldDefs, validations: validations, isStudioField: isStudioField, isSelected: isSelected, layoutParent: layouts[0], onHandleUpdate: updateRecord, viewScreen: viewScreen, moduleName: module || "Accounts" }) }, "key-".concat(key)));
                    }
                    //Defaul display a layout component
                    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "relative" }, { children: _jsx(LayoutComponentDisplay, { module: module, viewType: viewType, fieldDefs: fieldDefs, record: editedRecord, fetchedRecord: fetchedRecord, layouts: component, onHandleUpdate: updateRecord, validations: validations, isStudioField: isStudioField, isSelected: isSelected, layoutParent: layouts[0], viewScreen: viewScreen }, key) }), "key-".concat(key)) }));
                }), isStudioField && (_jsxs(_Fragment, { children: [_jsx(FormComponentButtons, { parentId: layoutParent, meta: (settings && settings) || [], isLayout: true, isSelected: isSelected === layouts[0].id }), _jsx(LayoutButtons, { parentId: layoutParent, component: layouts[0] || [], isLayout: true })] }))] })) })));
}
layoutComponentsDictionary.registerLayoutComponent("layout-rows", LayoutRows);
